import { MDBIcon } from "mdb-react-ui-kit";
import React, { useState, useEffect } from "react";

function Discount({ index, handleDiscountChange1, ...props }) {
    // console.log("propsprops", props);
    const [discountValues, setDiscountValues] = useState();
    const [discountUnit, setDiscountUnit] = useState("");

    useEffect(() => {
        if (props.data && props.data.discount) {
            setDiscountUnit(props.data.discount.discountType !== "percent" ? "₹" : "%");
            setDiscountValues(props.data.discount.EnterValue);
        } else {
            setDiscountUnit("");
            setDiscountValues("");
        }
    }, [props.data]); // Reset when data changes
    const totalPrice = Number(props.obj.Item.price);
    // const taxPercentage =
    // props.obj.taxPercent &&
    //     props.obj.taxPercent.length > 0 &&
    //     props.obj.taxPercent != "include"
    //     ? Number(props.obj.taxPercent[0])
    //     : 0;

    let taxPercentage = props.obj.taxamounts &&
        props.obj.taxamounts.length > 0 &&
        props.obj.taxamounts[props.obj.taxamounts.length - 1].TaxCheck === "Included"
        ?
        Number(props.obj.taxamounts.reduce((acc, obj) => {
            if (obj.percentage) {
                return acc + parseFloat(obj.percentage);
            }
            return acc;
        }, 0)
        )
        : 0;
    console.log(taxPercentage);
    const discountPercentage = discountValues;
    const taxAmount = totalPrice / (1 + (taxPercentage / 100));
    console.log(taxAmount);
    const totalPriceWithoutTax = taxAmount;
    console.log("&&&&&&%%%%%%%%%%%%%%%%%%%%%%%%%%", totalPriceWithoutTax);
    const discountAmount =
        discountUnit === "₹"
            ? discountValues
            : totalPriceWithoutTax * (discountPercentage / 100);
    console.log(discountAmount);
    let finalPrice = ((totalPriceWithoutTax - discountAmount));


    const handleDiscountChange = (e) => {
        const enteredValue = e.target.value;
        const maxDiscount = Number(
            props.obj.Item.discount === "0"
                ? "0"
                : props.obj.Item.discount === "1"
                    ? "5"
                    : props.obj.Item.discount === "2"
                        ? "10"
                        : props.obj.Item.discount === "3"
                            ? "15"
                            : props.obj.Item.discount === "4"
                                ? "50"
                                : props.obj.Item.discount === "5"
                                    ? "100"
                                    : "0"
        );

        if (discountUnit === "₹") {
            // Cap against totalPriceWithoutTax so final price never goes negative
            const maxRupeeAllowed = Number(((maxDiscount / 100) * totalPriceWithoutTax).toFixed(0));
            const rsDiscount = Number(enteredValue) > maxRupeeAllowed ? maxRupeeAllowed : enteredValue;
            setDiscountValues(rsDiscount);
            props.handleDiscountChange(index, rsDiscount, "rupees", rsDiscount, props.data._id);
        } else {
            const perDiscount = maxDiscount > Number(enteredValue) ? enteredValue : maxDiscount;
            const discountAmount = totalPriceWithoutTax * (perDiscount / 100);
            setDiscountValues(perDiscount);
            props.handleDiscountChange(index, perDiscount, "percent", discountAmount, props.data._id);
        }
    };

    // if (props.usersInfo && props.usersInfo.length > 0) {
    //     const totalDiscount = props.usersInfo.reduce((acc, _, index) => {
    //         console.log(Number(discountUnit[index] === "rs" ? discountValues[index] : ((discountValues[index] * props.actualprice / props.quantity) / 100) || 0));
    //         return acc + Number(discountUnit[index] === "rs" ? discountValues[index] : ((discountValues[index] * props.actualprice / props.quantity) / 100) || 0);
    //     }, 0);
    //     const averageDiscount = totalDiscount / props.usersInfo.length;
    //     tdiscount(averageDiscount);
    // }

    return (
        <>
            <div className="d-flex align-items-end justify-content-end w-400">
                <p className="m-0 w-100">
                    Discount: &nbsp;
                    <select
                        name=""
                        id=""
                        className="inp-clrdate-Small2"
                        onChange={(e) => {
                            e.preventDefault();
                            setDiscountUnit(e.target.value);
                            handleDiscountChange({ target: { value: "" } });
                        }}
                        value={discountUnit || ""}
                    >
                        <option value="%">%</option>
                        <option value="₹">₹</option>
                    </select>{" "}
                    <input
                        type="number"
                        name=""
                        className="inp-clrdate-Small me-2"
                        value={discountValues}
                        onChange={(e) => {
                            handleDiscountChange(e);
                        }}
                    />
                    {discountValues && (
                        <span className="ms-1 text-success">
                            <del>
                                <MDBIcon fas icon="rupee-sign" className="me-1" />
                                {totalPriceWithoutTax.toFixed(2)}
                            </del>

                            <strong className="ms-2">₹{(finalPrice).toFixed(2)}</strong>
                        </span>
                    )}
                </p>
            </div>
        </>
    );
}

export default Discount;
